import React from "react"
import { ButtonIconSeeker } from "@ui-seeker/core"
import { Box } from "@mui/material"


export default function ReportFormDrawerCsvTableActions({ onDownload, onDelete }) {

	return <Box sx={{ width: "100%" }}>
		<ButtonIconSeeker
			tooltip="Remove file"
			icon="trash"
			onClick={onDelete}
			sx={{
				color: "primary.main",
				display: 'inline-flex',
				alignItems: 'center',
			}}
		/>
		<ButtonIconSeeker
			tooltip="Download file"
			icon="download"
			onClick={onDownload}
			onAuxClick={onDownload}
			sx={{
				color: "primary.main",
				display: 'inline-flex',
				alignItems: 'center',
				height: 42,
				width: 42,
			}}
		/>
	</Box>
}